import { useCreateUserNoHashMutation } from "../../api/api-hooks";
import { UserForm } from "./userTypes";

const useUserItemCreatorWithPassword = () => {
  const [createUser] = useCreateUserNoHashMutation();
  return (item: UserForm, hashedPassword: string) => {
    if (item.name === undefined || item.email === undefined || !item.company)
      return { error: { data: { message: "Missing required fields" } } };
    return createUser({
      createUserDto: {
        ...item,
        name: item.name,
        email: item.email,
        companyId: item.company.id,
        password: hashedPassword,
        role: 2,
      },
    });
  };
};

export default useUserItemCreatorWithPassword;
